const Config = {   
    locale: {
        en: "EN",
        bm: "BM"
    },   
    cache: {
        languageKey: "PRUESUB_SELECTED_LANG",
        localeKey: "PRUESUB_LOCALE_LIBRARY",
        sessionID: "SESSIONID_",        
    }
}
export default Config;